$(document).ready(function () {

    var productDataText = $('#product-variants-data').html();

    if (productDataText) {
        var productData = JSON.parse(productDataText);

        var selectedVariant = productData.variants.find(function (variant) {
            return variant.id == selected_variant;
        });

        // price as per store currency formatting
        $('.price-block-new span.per-case').text('$' + (selectedVariant.price / 100).toFixed(2));
        $('.price-block-new span.case-size').text(selectedVariant.case_size);

    }


    // on variant change console log the selected variant data
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event.data.variant;
        
        var selectedVariant = productData.variants.find(function (v) {
            return v.id == variant.id;
        });
        
        // Update the price and case size in the DOM
        $('.price-block-new span.per-case').text('$' + (selectedVariant.price / 100).toFixed(2));
        $('.price-block-new span.case-size').text(selectedVariant.case_size);
    });

});